/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import {
  Button, Form, Input, Popconfirm, InputNumber,
} from 'antd';
import PropTypes from 'prop-types';
import SmetaRow from './SmetaRow';


const Smeta = ({ coexecutorData, formRef }) => {
  const projectYears = () => {
    const years = [];
    if (coexecutorData.coexecutorsPersonId.isStep1 || coexecutorData.coexecutorsPersonId.isStep2) {
      years.push('2025');
    }

    if (coexecutorData.coexecutorsPersonId.isStep3 || coexecutorData.coexecutorsPersonId.isStep4) {
      years.push('2026');
    }

    if (coexecutorData.coexecutorsPersonId.isStep5 || coexecutorData.coexecutorsPersonId.isStep6) {
      years.push('2027');
    }
    return years;
  };

  const getTotalByYear = (year) => {
    switch (year) {
      case '2025':
        return (coexecutorData.coexecutorsPersonId.step1Sum || 0) + (coexecutorData.coexecutorsPersonId.step2Sum || 0);
      case '2026':
        return (coexecutorData.coexecutorsPersonId.step3Sum || 0) + (coexecutorData.coexecutorsPersonId.step4Sum || 0);
      case '2027':
        return (coexecutorData.coexecutorsPersonId.step5Sum || 0) + (coexecutorData.coexecutorsPersonId.step6Sum || 0);
      default:
        return 0;
    }
  };

  return (
    <>
      <div className="common-subTitle" style={{ marginTop: '40px' }}>
        <b>Смета расходов Соисполнителя</b>
      </div>

      <div className="common-table-wrapper" style={{ marginTop: '10px' }}>
        <div className="common-table-row">
          <div
            className="common-table-row-cell"
            style={{ width: '5%', textAlign: 'center', fontWeight: 'bold' }}
          >
            № п/п
          </div>
          <div
            className="common-table-row-cell"
            style={{ width: '25%', textAlign: 'center', fontWeight: 'bold' }}
          >
            Наименование статей расходов
          </div>
          <div
            className="common-table-row-cell"
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '70%',
              padding: '4px 0px 0px 0px',
              borderRight: '1px solid #d9d9d9',
            }}
          >
            <div
              className="common-table-row-cell"
              style={{
                width: '100%',
                textAlign: 'center',
                border: 'none',
                fontWeight: 'bold',
              }}
            >
              Средства финансирования
            </div>
            <div className="common-table-row">
              <div
                className="common-table-row-cell"
                style={{
                  width: '30%',
                  textAlign: 'center',
                  borderLeft: '0',
                  fontWeight: 'bold',
                }}
              >
                Всего
              </div>
              {projectYears().map((e) => (
                <div
                  className="common-table-row-cell"
                  style={{
                    width: `${70 / projectYears().length}%`,
                    textAlign: 'center',
                    fontWeight: 'bold',
                  }}
                  key={e}
                >
                  {e}
                </div>
              ))}
              <div
                className="common-table-row-cell"
                style={{
                  width: `${15}%`,
                  textAlign: 'center',
                  fontWeight: 'bold',
                }}
              >
                Доля затрат, %
              </div>
            </div>
          </div>
        </div>

        {new Array(5).fill(0).map((e, i) => (
          <SmetaRow
            index={i}
            coexecutorData={coexecutorData}
            projectYears={projectYears()}
            formRef={formRef}
          />
        ))}

        <div
          className="common-table-row"
          style={{ borderBottom: '1px solid #d9d9d9' }}
        >
          <div
            className="common-table-row-cell"
            style={{ width: '5%', textAlign: 'center' }}
          />
          <div
            className="common-table-row-cell"
            style={{ width: '25%', textAlign: 'right', fontWeight: 'bold' }}
          >
            ИТОГО
          </div>
          <div className="common-table-row" style={{ width: '70%' }}>
            <div
              className="common-table-row-cell"
              style={{
                width: '30%',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Form.Item
                style={{ width: '55%' }}
              >
                <InputNumber value={coexecutorData.coexecutorsPersonId.stepTotal} disabled />
              </Form.Item>
              <span>руб.</span>
            </div>
            {projectYears().map((year) => (
              <div
                key={year}
                className="common-table-row-cell"
                style={{
                  width: `${70 / projectYears().length}%`,
                  textAlign: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <Form.Item
                  style={{ width: '55%' }}
                >
                  <InputNumber value={getTotalByYear(year)} disabled />
                </Form.Item>
                <span>руб.</span>
              </div>
            ))}
            <div
              className="common-table-row-cell"
              style={{
                width: `${15}%`,
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                borderRight: '1px solid #d9d9d9',
              }}
            >
              <Form.Item
                style={{ width: '55%' }}
              >
                <InputNumber
                  disabled
                  value={100}
                  formatter={(value) => (parseInt(value, 10) || 0).toLocaleString('ru-RU')}
                />
              </Form.Item>
              <span>%</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Smeta.propTypes = {
  coexecutorData: PropTypes.shape().isRequired,
  formRef: PropTypes.shape().isRequired,
};

export default Smeta;
